import { ReactElement } from "react";

import { UIGraphNode } from "../types/graph";
import { GraphDetailField } from "./GraphDetailField";
import { GraphDetailText } from "./GraphDetailText";

interface ConnectionItemProps {
  item: { entityName?: string } & UIGraphNode["data"];
}

export const GraphConnectionItem = ({
  item,
}: ConnectionItemProps): null | ReactElement => {
  if (!item.entityName) {
    return null;
  }

  return (
    <GraphDetailField label={item.entityName}>
      <GraphDetailText text={item.value} />
    </GraphDetailField>
  );
};
